import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  // eslint-disable-next-line
  constructor(private httpClient: HttpClient) {}

  getUtils() {
    return this.httpClient.get(environment.api.base + 'utils/data');
  }
}
